<template lang="pug">
  div.consume
    van-dropdown-menu(class="select_box")
      van-dropdown-item(v-model="active", :options="status")
    van-list(v-model="listLoading", @load="onListLoad", :loading-text="$t('loading')", :finished-text="$t('noMore')", error-text="...", :finished="finished")
      div(class="hst_box van-clearfix", v-for='(item, key) in orderList', v-if="item.status > -1", :key="key" @click="toChatPage(item)")
        van-collapse-item(class="consume_list")
          template(#icon)
            img(class="consume_icon", :src="item.goodsIcon")
          template(#title)
            p.title {{item.subOrderCount > 1 ? $t('multiName') : item.goodsName}}
            p.time {{formatDate(item.paySuccessTime || item.createTime, true)}}
          template(#value)
            p.status {{formatStatus(item.status)}}
    //- van-overlay(:show='loadShow', @click="loadShow = false")
    //-   van-loading(type="spinner", color="#e60012")
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import Qs from 'qs';
import moment from 'moment'

export default {
  name: 'Consume',
  data($vm){
    return{
      accessToken: '',
      language: '',
      active: '',
      record: '',
      orderList:[],
      pageNumber: 1,
      listLoading: false,
      finished: false,
      loadStatus: true,
      loadShow: false,
      env: ''
    }
  },
  created(){
  },
  methods:{
    ...mapActions(['getThirdPayOrderList']),
    onListLoad(){
      if(this.loadStatus){
        return false
      }
      this.loadStatus = true
      this.loadShow = true
      this.pageNumber += 1
      this.getThirdPayOrderList({
        uid: this.$route.query.uid,
        accessToken: this.accessToken,
        pageNumber: this.pageNumber,
        language: this.language,
        appId: this.$route.query.appId,
        serverId: this.$route.query.serverId,
        roleId: this.$route.query.roleId,
        areaId: this.$route.query.areaId,
        status: this.active
      })
    },
    toChatPage(data){
      this.$router.push({
        path: '/content',
        query: data
      })
    }
  },
  computed:{
    ...mapGetters(['orderInfo', 'orderLoading']),
    status: $vm => {
      return [
        {
          text: $vm.$t('all'),
          value: ''
        },
        {
          text: $vm.$t('toBePaid'),
          value: '0'
        },
        {
          text: $vm.$t('tradeSuccess'),
          value: '100'
        }
      ]
    },
    formatDate: (val, key = false) => {
      return (val, key= false) => {
        if(key){
          return moment(parseInt(val)).format('YYYY-MM-DD HH:mm:ss') + '    ' + 'UTC+' + (0 - new Date().getTimezoneOffset() / 60)
        } else {
          return moment(parseInt(val)).format('YYYY-MM-DD HH:mm:ss')
        }
      }
    },
    formatStatus: $vm => {
      return val => {
        if(val === '0'){
          return $vm.$t('toBePaid')
        } else if(val === '100'){
          return $vm.$t('tradeSuccess')
        }
      }
    }
  },
  mounted(){
    this.env = CONFIG.env
    this.accessToken = window.localStorage.getItem('accessToken')
    this.language = window.localStorage.getItem('language')
    this.loadShow = true
    this.getThirdPayOrderList({
      uid: this.$route.query.uid,
      accessToken: this.accessToken,
      pageNumber: this.pageNumber,
      language: this.language,
      appId: this.$route.query.appId,
      serverId: this.$route.query.serverId,
      roleId: this.$route.query.roleId,
      areaId: this.$route.query.areaId,
      pageNumber: 1,
    })
    this.$watch(() => window.i18n.locale, val => {
      this.orderList = []
      this.loadShow = true
      this.getThirdPayOrderList({
        uid: this.$route.query.uid,
        accessToken: this.accessToken,
        pageNumber: this.pageNumber,
        language: val,
        appId: this.$route.query.appId,
        serverId: this.$route.query.serverId,
        roleId: this.$route.query.roleId,
        areaId: this.$route.query.areaId,
        pageNumber: 1,
        status: this.active
      })
    })
    this.$watch('orderLoading', val => {
      if(val === 'loaded'){
        this.orderInfo.list.map(val => {
          this.orderList.push(val)
        })
        // console.log(this.orderList)
        if(this.orderList.length == this.orderInfo.total){
          this.finished = true
        }
        this.loadShow = false
        this.loadStatus = false
        this.listLoading = false
      }
    })
    this.$watch('active', val => {
      this.pageNumber = 1
      this.loadShow = true
      this.loadStatus = true
      this.finished = false
      this.orderList = []
      this.getThirdPayOrderList({
        uid: this.$route.query.uid,
        accessToken: this.accessToken,
        pageNumber: this.pageNumber,
        language: this.language,
        appId: this.$route.query.appId,
        serverId: this.$route.query.serverId,
        roleId: this.$route.query.roleId,
        areaId: this.$route.query.areaId,
        pageNumber: 1,
        status: val
      })
    })
  }
}
</script>
<style lang="scss">
.consume{
  margin: 20px;
  .van-dropdown-menu__item{
    margin: 0 4px;
  }
  .van-dropdown-menu__title::after{
    right: 0px;
  }
  .select_box{
    width: 50%;
    position: relative;
    left: 50%;
    .van-dropdown-menu__bar{
      height: 30px;
    }
  }
  .consume_list{
    margin-top: 10px;
    .van-cell__value{
      position: absolute;
      right: 40px;
      line-height: 60px;
      p{
        margin: 0;
      }
    }
    .van-cell__right-icon{
      line-height: 60px;
    }
    .van-collapse-item__content{
      p{
        margin: 0;
        padding: 5px 10px;
      }
    }
  }
  .consume_icon{
    height: 60px;
    width: 60px;
    position: relative;
  }
  .title{
    margin: 0;
    font-size: 18px;
    color: #000;
    padding-left: 10px;
    font-weight: bolder;
  }
  .time{
    margin: 0;
    font-size: 12px;
    color: #969799;
    padding-left: 10px;
    margin-top: 12px;
  }
  .van-hairline--top-bottom::after{
    border-width: 0px;
  }
}
</style>